import styled from "styled-components";
import { Nav, NavItem } from "react-bootstrap";
import { NavDropdown } from "react-bootstrap";

interface INavWrapperProps {
    verticalAlign?: string,
    minTabWidth?: string,
    fontSize?: string
}

export const NavWrapper = styled(Nav) <INavWrapperProps>`
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 10px;

    & > .center-tabs > li {
        height: 48px;
    }

    & > .center-tabs > li > a {
        font-size: 14px;
        font-weight: 500;
        background-color: #337ab7;
        color: white;
        // width: 160px;
        text-align: center;
        // line-height: 15px;
        padding: 5px 15px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: ${(p: INavWrapperProps) => p.verticalAlign ? p.verticalAlign : 'flex-end'};
        min-width: ${(p: INavWrapperProps) => p.minTabWidth ? p.minTabWidth + 'px !important' : '0px'};
    }

    & > .center-tabs > li.active > a {
        color: #555;
        background-color: #fff;
    }

    & > div > .center-pills > li > a {
        padding: 5px 7px;
        // font-size: ${(p: INavWrapperProps) => p.fontSize != null ? p.fontSize : '14px'};
        // display: flex;
        // flex-direction: column;
        // justify-content: center;
    }

    & > div > .center-pills > li > span {
        position: relative;
        display: block;
        font-size: 12px;
        padding: 5px 2px;
        color: #ccc;
        // min-height: 72px;
    }

    & > div > .center-pills > li > div.pill-divider {
        margin-left: 3px;
        margin-right: 3px;
        margin-top: 9px;
        height: 10px;
        width: 1px;
        background-color: #ccc;
        // border: 0.5px solid #ccc
    }

    & > div > .center-pills > li > div.pill-divider {
        margin-left: 3px;
        margin-right: 3px;
        margin-top: 9px;
        height: 10px;
        width: 1px;
        background-color: #ccc;
        // border: 0.5px solid #ccc
    }

    & > li > a:hover {
        background-color: #a0c5e5;
        color: black;
    }

    & > li > a.action {
        background-color: white;
        color: black;
    }

    & > li.active > a {
        // font-size: 14px;
        // line-height: 15px;
        // padding: 5px 7.5px;
    }

    @media (max-width: 1823px) {
        & > li > a,
        & > li.active > a {
            font-size: 12px;
            min-width: 120px;
        }
    }
`;

export const NavSubWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    // margin-bottom: 20px;
    // border: 1px solid red;

    & > div > .center-pills > li > a {
        padding: 5px 7px;
    }

    & > div > .center-pills > li > span {
        position: relative;
        display: block;
        font-size: 12px;
        padding: 5px 7px;
        color: #ccc;
    }

    & > div > .center-pills > li > div.pill-divider {
        margin-left: 3px;
        margin-right: 3px;
        margin-top: 9px;
        height: 10px;
        width: 1px;
        background-color: #ccc;
        // border: 0.5px solid #ccc
    }

    & > li > a:hover {
        background-color: #a0c5e5;
        color: black;
    }

    & > li > a.action {
        background-color: white;
        color: black;
    }

    & > li.active > a {
        // font-size: 14px;
        // line-height: 15px;
        // padding: 5px 7.5px;
    }

    @media (max-width: 1823px) {
        & > li > a,
        & > li.active > a {
            font-size: 12px;
            min-width: 120px;
        }
    }
`;

interface INavSubWrapper2Props {
    height?: string
}

export const NavSubWrapper2 = styled(Nav) <INavSubWrapper2Props>`
    & > li {
        height: ${(p: INavSubWrapper2Props) => p.height ? p.height : '50px'};
    }

    & > li > a {
        height: ${(p: INavSubWrapper2Props) => p.height ? p.height : '50px'};
    }

    & > li.divider {
        display: flex;
        align-items: center;
        color: #ddd;
        padding-left: 5px;
        padding-right: 5px;
    }
`;

interface INavItemProps {
    minTabWidth?: string
}

export const NavItemWrapper = styled(NavItem) <INavItemProps>`
    // & > a {
    //     width: ${(p: INavItemProps) => p.minTabWidth ? p.minTabWidth + 'px !important' : '150px'};
    // }

    // & > a {
    //     min-width: ${(p: INavItemProps) => p.minTabWidth ? p.minTabWidth + 'px !important' : '0px'};
    // }

    & > a {
        height: 30px;
        // border-radius: 8px !important;
        text-align: center;
        // border: 1px solid #337ab7;
        // min-height: 50px;
        display: flex !important;
        align-items: center;
    }

    & > a > span.badge {
        font-size: 10px;
    }

    & > a > span.type-count {
        font-size: 12px;
    }

`;


export const NavDropdownWrapper = styled(NavDropdown)`
    & > ul > li {
        margin-left: 20px;
    }

  & > .child {
  display: inline-block;
  border: 1px solid red;
  padding: 1rem 1rem;
  vertical-align: middle;
}
`;